<template>
  <vx-card :title="$t('shippingDetail.shippingDetail')" id="shipping-detail">
    <template slot="actions">
      <div class="vx-row">
        <vs-button
          v-if="selectedOrderData && selectedOrderData.external_tracking_url"
          class="mr-2"
          size="small"
          title="External Tracking Page"
          alt="External Tracking Page"
          type="gradient"
          icon-pack="feather"
          icon="icon-package"
          color="secondary"
          @click="goToExternalTracking()"
        >
        </vs-button>
        <vs-button
          class="mr-2"
          size="small"
          title="Tracking Page"
          alt="Tracking Page"
          type="gradient"
          icon-pack="feather"
          icon="icon-package"
          color="primary"
          @click="goToTracking()"
        ></vs-button>
      </div>
    </template>
    <div id="shipping-detail__body">
      <div class="text-center align-items-center justify-center" v-if="!selectedOrderData">
        <img src="/images/ilust/graphic-6.png" alt="content-img" class="rounded-lg mb-6" style="display: inline" />
        <p>{{ $t("shippingDetail.clickOrder") }}</p>
      </div>
      <div v-else>
        <div class="vx-row">
          <div class="vx-col w-full mb-3" v-if="selectedOrderData.is_rating_customer">
            <vs-alert color="success">
              <div class="text-center mb-4">{{ $t("shippingDetail.thankYouRating") }}!</div>
              <star-rating
                :show-rating="false"
                :read-only="true"
                :star-size="30"
                :rating="parseInt(selectedOrderData.is_rating_customer.rating)"
              ></star-rating>
              <!-- <div class="mt-2 text-center">
                    <small>{{selectedOrderData.is_rating_customer.note}}</small>
                  </div> -->
            </vs-alert>
          </div>
          <div class="vx-col w-full mb-3 text-center" v-if="selectedOrderData.can_rate">
            <vs-button
              size="small"
              title="Review order"
              alt="Review order"
              type="gradient"
              icon-pack="feather"
              icon="icon-star"
              color="warning"
              @click="openRatingDialog()"
            >
              <span class="text-capitalize">{{ $t("shippingDetail.rateOrder") }}</span>
            </vs-button>
          </div>
          <div class="vx-col w-full">
            <small class="activity-desc">{{ $t("attribute.orderNumber") }} </small>
            <br />
            <p class="text-xl font-bold mb-3">
              {{ selectedOrderData.unique_id }}
              <span v-if="selectedOrderData.customer_ref_id">- {{ selectedOrderData.customer_ref_id }}</span>
            </p>
            <vs-button size="small" type="gradient" color="success" @click="printReceipt()">
              <span class="text-capitalize">{{ $t("attribute.receipt") }}</span>
            </vs-button>
            <vs-button size="small" type="gradient" color="primary" @click="printWaybill()" v-if="!awbBase64">
              <span class="text-capitalize">{{ $t("attribute.waybill") }}</span>
            </vs-button>
            <vs-button size="small" type="gradient" color="primary" @click="printAirWaybill()" v-if="awbBase64">
              <span class="text-capitalize">{{ $t("attribute.airWaybill") }}</span>
            </vs-button>
            <vs-button size="small" type="gradient" color="primary" @click="printInvoice()" v-if="invoiceBase64">
              <span class="text-capitalize">{{ $t("attribute.invoice") }}</span>
            </vs-button>
            <vs-button
              size="small"
              color="warning"
              @click="cancelOrder()"
              v-if="
                selectedOrderData.status == 'ORDERED' ||
                  selectedOrderData.status == 'ACKNOWLEDGED' ||
                  selectedOrderData.status == 'ACCEPTED' ||
                  selectedOrderData.status == 'FAILED COLLECTION'
              "
            >
              <span class="text-capitalize">{{ $t("action.cancel") }}</span>
            </vs-button>
            <vs-button
              size="small"
              color="success"
              @click="enrouteOrderDialogVisibility = true"
              v-if="showEnrouteButton"
            >
              <span class="text-capitalize">{{ $t("action.enroute") }}</span>
            </vs-button>
          </div>
        </div>

        <vs-divider></vs-divider>

        <!---PAYMENT--->
        <small class="activity-desc">{{ $t("attribute.payment") }} </small>
        <p class="font-bold">
          {{ renderCurrency(selectedOrderData.total_price, selectedOrderData.currency) }} |
          {{ selectedOrderData.payment_method }}
        </p>
        <!---END PAYMENT--->

        <vs-divider></vs-divider>

        <div>
          <div class="vx-row">
            <!---PICKUP DATE--->
            <div class="vx-col w-full lg:w-1/2 mb-3">
              <small class="activity-desc" v-if="selectedOrderData.delivery_type == deliveryTypeEnum.SAME_DAY_DELIVERY">
                {{ $t("shippingDetail.pickupAfter") }}
              </small>
              <small
                class="activity-desc"
                v-else-if="selectedOrderData.delivery_type == deliveryTypeEnum.ON_DEMAND_DELIVERY"
              >
                {{ $t("shippingDetail.pickupAt") }}
              </small>
              <small
                class="activity-desc"
                v-else-if="selectedOrderData.delivery_type == deliveryTypeEnum.ONE_TO_THREE_DAYS_DELIVERY"
              >
                {{ $t("shippingDetail.estimatedPickupBefore") }}
              </small>
              <small class="activity-desc" v-else>{{ $t("shippingDetail.pickupBefore") }}</small>
              <br />
              <p
                class="font-bold"
                v-if="selectedOrderData.delivery_type !== deliveryTypeEnum.ONE_TO_THREE_DAYS_DELIVERY"
              >
                {{ renderToHumanDate(selectedOrderData.booking_date) }}
              </p>
              <p
                class="font-bold"
                v-if="selectedOrderData.delivery_type == deliveryTypeEnum.ONE_TO_THREE_DAYS_DELIVERY"
              >
                <span
                  v-if="
                    checkIfSameMonthYear(
                      selectedOrderData.booking_date,
                      selectedOrderData.req_pickup_date,
                      'YYYY-MM-DDTHH:mm:ss',
                      'YYYY-MM-DDTHH:mm:ss'
                    )
                  "
                >
                  {{ renderMoment(selectedOrderData.booking_date, "YYYY-MM-DDTHH:mm:ss", "DD") }} -
                  {{ renderMoment(selectedOrderData.req_pickup_date, "YYYY-MM-DDTHH:mm:ss", "DD") }}&nbsp;
                  {{ renderMoment(selectedOrderData.booking_date, "YYYY-MM-DDTHH:mm:ss", "MMM YYYY") }},
                </span>
                <span
                  v-if="
                    !checkIfSameMonthYear(
                      selectedOrderData.booking_date,
                      selectedOrderData.req_pickup_date,
                      'YYYY-MM-DDTHH:mm:ss',
                      'YYYY-MM-DDTHH:mm:ss'
                    )
                  "
                >
                  {{ renderMoment(selectedOrderData.booking_date, "YYYY-MM-DDTHH:mm:ss", "DD MMM YYYY") }}
                  -
                  {{ renderMoment(selectedOrderData.req_pickup_date, "YYYY-MM-DDTHH:mm:ss", "DD MMM YYYY") }}
                </span>
                {{ renderMoment(selectedOrderData.booking_date, "YYYY-MM-DDTHH:mm:ss", "HH:mm") }}
              </p>
            </div>
            <!---END PICKUP DATE--->

            <!---DELIVERY DATE--->
            <div class="vx-col w-full lg:w-1/2 mb-3">
              <small
                class="activity-desc"
                v-if="selectedOrderData.delivery_type !== deliveryTypeEnum.ON_DEMAND_DELIVERY"
              >
                {{ $t("shippingDetail.estimatedDeliveryBefore") }}
              </small>
              <small class="activity-desc" v-else>{{ $t("shippingDetail.estimatedDeliveryAt") }}</small>
              <br />
              <p
                class="font-bold"
                v-if="
                  selectedOrderData.delivery_date &&
                    selectedOrderData.delivery_type !== deliveryTypeEnum.ONE_TO_THREE_DAYS_DELIVERY
                "
              >
                {{ renderToHumanDate(selectedOrderData.delivery_date) }}
              </p>
              <p
                class="font-bold"
                v-else-if="selectedOrderData.delivery_type == deliveryTypeEnum.ONE_TO_THREE_DAYS_DELIVERY"
              >
                <span
                  v-if="
                    checkIfSameMonthYear(
                      selectedOrderData.req_pickup_date,
                      selectedOrderData.delivery_date,
                      'YYYY-MM-DDTHH:mm:ss',
                      'YYYY-MM-DDTHH:mm:ss'
                    )
                  "
                >
                  {{ renderMoment(selectedOrderData.req_pickup_date, "YYYY-MM-DDTHH:mm:ss", "DD") }} -
                  {{ renderMoment(selectedOrderData.delivery_date, "YYYY-MM-DDTHH:mm:ss", "DD") }}&nbsp;
                  {{ renderMoment(selectedOrderData.req_pickup_date, "YYYY-MM-DDTHH:mm:ss", "MMM YYYY") }},
                </span>
                <span
                  v-if="
                    !checkIfSameMonthYear(
                      selectedOrderData.req_pickup_date,
                      selectedOrderData.delivery_date,
                      'YYYY-MM-DDTHH:mm:ss',
                      'YYYY-MM-DDTHH:mm:ss'
                    )
                  "
                >
                  {{ renderMoment(selectedOrderData.req_pickup_date, "YYYY-MM-DDTHH:mm:ss", "DD MMM YYYY") }}
                  -
                  {{ renderMoment(selectedOrderData.delivery_date, "YYYY-MM-DDTHH:mm:ss", "DD MMM YYYY") }}
                </span>
                {{ renderMoment(selectedOrderData.req_pickup_date, "YYYY-MM-DDTHH:mm:ss", "HH:mm") }}
              </p>
              <p v-else>
                <i>--- {{ $t("shippingDetail.notAvailable") }} ---</i>
              </p>
            </div>
            <!---END DELIVERY DATE--->
          </div>

          <div v-if="selectedOrderData.can_reschedule">
            <vs-button size="small" type="gradient" color="primary" class="mb-3" @click="reschedule()">
              <span class="text-capitalize">{{ $t("action.reschedule") }}</span>
            </vs-button>
            <br />
          </div>

          <small>
            <i>
              <i18n path="shippingDetail.contactQuery" tag="label">
                <strong>*{{ $t("attribute.liveChat") }}</strong>
              </i18n>
            </i>
          </small>
        </div>

        <vs-divider></vs-divider>

        <!---REQ PICKUP DATE-->
        <div
          v-if="
            selectedOrderData.req_pickup_date &&
              selectedOrderData.delivery_type !== deliveryTypeEnum.ONE_TO_THREE_DAYS_DELIVERY
          "
        >
          <div class="vx-row">
            <div class="vx-col">
              <small class="activity-desc">{{ $t("shippingDetail.requestCollectionBefore") }} </small>
              <br />
              <p class="font-bold">{{ renderToHumanDate(selectedOrderData.req_pickup_date) }}</p>
            </div>
          </div>

          <vs-divider></vs-divider>
        </div>
        <!---END REQ PICKUP DATE-->

        <!---DRIVER DETAIL--->
        <div v-if="selectedOrderData.driver">
          <small class="activity-desc">{{ $t("shippingDetail.driverDetail") }}</small>
          <div v-if="selectedOrderData.driver.name">
            <div class="mb-2" v-if="selectedOrderData.delivery_type == deliveryTypeEnum.SAME_DAY_DELIVERY">
              <vs-button size="small" @click="liveTracking()" type="gradient">
                <span class="text-capitalize">{{ $t("action.liveTracking") }}</span>
              </vs-button>
            </div>

            <div>
              <span class="text-capitalize">{{ $t("attribute.name") }}</span
              >: <span class="font-bold">{{ selectedOrderData.driver.name }}</span>
            </div>
            <div v-if="selectedOrderData.driver.contact_no">
              <span class="text-capitalize">{{ $t("attribute.phoneNumber") }}</span
              >:
              <a :href="`tel:${selectedOrderData.driver.contact_no}`">{{ selectedOrderData.driver.contact_no }}</a>
            </div>
          </div>
          <div v-else>
            <i>--- {{ $t("dashboard.noDriver") }} ---</i>
          </div>
          <vs-divider></vs-divider>
        </div>
        <!---END DRIVER DETAIL--->

        <!---DESTINATION--->
        <vx-destination class="mt-3 mb-base" :data="renderTimelineData(selectedOrderData)" />
        <!---END DESTINATION-->

        <vs-divider></vs-divider>

        <!---GOOD TYPE--->
        <div v-if="selectedOrderData.delivery_type !== deliveryTypeEnum.ON_DEMAND_DELIVERY">
          <small class="activity-desc">{{ $t("attribute.goodType") }}</small>
          <div>
            <span class="font-bold" v-if="selectedOrderData.dropoff_count < 2">
              {{ selectedOrderData.good_type.name }}
            </span>
            <template v-if="selectedOrderData.dropoff_count >= 2">
              <span
                class="font-bold"
                v-for="(dropoff, index) in selectedOrderData.dropoffs"
                :key="`good_type_dropoff_${index}`"
              >
                {{ dropoff.good_type.name }}
                {{ index == selectedOrderData.dropoff_count - 1 ? "" : "| " }}
              </span>
            </template>
            <vs-divider></vs-divider>
          </div>
        </div>
        <!---END GOOD TYPE--->

        <!---PACKAGES--->
        <div v-if="selectedOrderData.packages.length > 0">
          <small class="activity-desc">{{ $t("attribute.package") }}</small>
          <div v-for="(item, index) in selectedOrderData.packages" :key="index">
            <p class="font-bold text-primary">
              <span v-if="item.item_desc">{{ item.item_desc }} - </span>{{ item.qty }} pcs
            </p>
            <p>
              {{ item.length }} cm x {{ item.width }} cm x {{ item.height }} cm ({{ item.weight }}
              kg)
            </p>
          </div>

          <vs-divider></vs-divider>
        </div>
        <!---END PACKAGES--->

        <!---GOOD SIZE--->
        <template v-else>
          <div class="w-full" v-if="selectedOrderData.good_size">
            <p class="font-bold text-primary" v-if="'name' in selectedOrderData.good_size">
              {{ selectedOrderData.good_size.name }}
            </p>
            <p class="activity-desc" v-if="'desc' in selectedOrderData.good_size">
              {{ selectedOrderData.good_size.desc }}
            </p>
            <vs-divider></vs-divider>
          </div>
          <div class="vx-col w-full text-center" v-else>
            <i class="text-capitalize">--- {{ $t("shippingDetail.packageNotAvailable") }} ---</i>
            <vs-divider></vs-divider>
          </div>
        </template>
        <!---END GOOD SIZE-->

        <!---VEHICLE TYPE--->
        <div v-if="selectedOrderData.vehicle_type">
          <div class="mb-3">
            <small class="activity-desc">{{ $t("attribute.vehicle") }}</small>
          </div>
          <div class="vx-row">
            <div class="vx-col">
              <img :src="selectedOrderData.vehicle_type.icon_path" style="height:50px" />
            </div>
            <div class="vx-col">
              <div class="font-bold">{{ selectedOrderData.vehicle_type.name }}</div>
              <small>
                {{ selectedOrderData.vehicle_type.length }} cm x {{ selectedOrderData.vehicle_type.width }} cm x
                {{ selectedOrderData.vehicle_type.height }} cm
                {{ selectedOrderData.vehicle_type.weight ? `, ${selectedOrderData.vehicle_type.weight} kg` : "" }}
              </small>
            </div>
          </div>
          <vs-divider></vs-divider>
        </div>
        <!---END VEHICLE TYPE--->

        <!---ADDON--->
        <div v-if="selectedOrderData.addons.length > 0">
          <div class="mb-3">
            <small class="font-bold text-uppercase">{{ $t("attribute.addon") }}</small>
          </div>
          <div class="w-full">
            <vs-button
              size="small"
              class="mr-2 mb-2"
              v-for="(item, index) in selectedOrderData.addons"
              :key="`selected_addon_${index}`"
            >
              {{ item.name }}
            </vs-button>
          </div>
          <vs-divider></vs-divider>
        </div>
        <!---END ADDON--->

        <!---TRACKING HISTORY--->
        <div class="mb-3">
          <small class="activity-desc">{{ $t("attribute.trackingHistory") }}</small>
        </div>
        <template v-if="'histories' in selectedOrderData">
          <div class="w-full" v-for="(history, index) in selectedOrderData.histories" :key="index">
            <small class="activity-desc"> {{ renderToHumanDate(history.created_at) }} </small>
            <p class="font-bold text-primary">{{ history.status }}</p>
            <p>{{ history.remarks }}</p>
            <vs-divider></vs-divider>
          </div>
        </template>
        <template v-else>
          <div class="text-center">
            <i> --- {{ $t("general.notAvailable", { msg: $t("attribute.trackingHistory") }) }} --- </i>
          </div>
        </template>
        <!---END TRACKING HISTORY--->
      </div>
    </div>

    <vs-popup
      button-close-hidden
      v-bind:title="$t('shippingDetail.rateYourOrder')"
      :active.sync="ratingDialogVisibility"
      prevent-close
      style="z-index: 20000"
    >
      <form>
        <div class="vx-row">
          <div class="vx-col w-full mb-4">
            <star-rating glow-color="#f48024" :glow="5" :show-rating="false" v-model="rate.point"></star-rating>
            <input name="rating" type="hidden" v-model="rate.point" v-validate="'required'" />
            <small class="text-danger text-sm" v-show="errors.has('rating')">
              {{ $t("shippingDetail.selectStar") }}
            </small>
          </div>
          <div class="vx-col w-full mb-2">
            <vs-input
              name="Remarks"
              icon-no-border
              icon="icon icon-package"
              icon-pack="feather"
              v-bind:placeholder="$t('attribute.remark')"
              v-model="rate.note"
              class="w-full"
            />
          </div>
        </div>
      </form>
      <div class="vx-col w-full mb-2">
        <vs-button type="filled" @click="onClickSubmitRate()" class="mr-2 mt-5 float-right">
          <span class="text-uppercase">{{ $t("action.rate") }}</span>
        </vs-button>
        <vs-button type="flat" @click="ratingDialogVisibility = false" class="mr-2 mt-5 float-right">
          <span class="text-uppercase">{{ $t("action.close") }}</span>
        </vs-button>
      </div>
    </vs-popup>
    <vs-popup
      button-close-hidden
      v-bind:title="$t('shippingDetail.selectPaperSize')"
      :active.sync="paperSizeDialogVisibility"
      prevent-close
      style="z-index: 20000"
    >
      <div class="vx-col w-full">
        <div class="vx-row w-full">
          <div class="vx-col sm:w-1/3 md:w-1/5 mb-2" v-for="(size, index) in waybillPaperSizes" :key="index">
            <vs-button
              class="text-capitalize font-bold w-full p-3 pr-5 pl-5"
              type="filled"
              @click="onClickPrintWaybill(size)"
            >
              {{ size.toUpperCase() }}
            </vs-button>
          </div>
        </div>
      </div>
    </vs-popup>
    <vs-popup
      button-close-hidden
      v-bind:title="$t('shippingDetail.enrouteOrder')"
      :active.sync="enrouteOrderDialogVisibility"
      prevent-close
      style="z-index: 20000"
    >
      <div class="vx-col w-full">
        <div class="text-md">{{ $t("shippingDetail.enrouteConfirmation") }}.</div>
        <vs-divider></vs-divider>
        <div class="flex justify-between flex-wrap">
          <vs-button @click="enrouteOrderDialogVisibility = false" type="border" color="primary">
            <span class="text-uppercase">{{ $t("action.close") }}</span>
          </vs-button>
          <vs-button @click="enrouteOrder()" type="filled" color="primary">
            <span class="text-uppercase">{{ $t("action.enroute") }}</span>
          </vs-button>
        </div>
        <div class="vx-col">
          <div class="mb-2" v-for="error in enrouteErrors" :key="error.message">
            <vs-alert color="danger" icon="new_releases">
              <span>{{ error }}</span>
            </vs-alert>
          </div>
        </div>
      </div>
    </vs-popup>
    <vs-popup
      button-close-hidden
      v-bind:title="$t('shippingDetail.cancelOrder')"
      :active.sync="cancelOrderDialogVisibility"
      prevent-close
      style="z-index: 20000"
      :key="cancelOrderDialogKey"
      v-if="selectedOrderData"
    >
      <div class="vx-col">
        <div class="mb-2" v-for="error in cancelErrors" :key="error.message">
          <vs-alert color="danger" icon="new_releases">
            <span>{{ error }}</span>
          </vs-alert>
        </div>
      </div>
      <div class="vx-col w-full">
        <div class="vx-col text-md" v-html="cancellable.text"></div>
        <vs-divider
          v-if="selectedOrderData && selectedOrderData.delivery_type == deliveryTypeEnum.ONE_TO_THREE_DAYS_DELIVERY"
          ><span @click="onClickPrintWaybill('a5')" class="cursor-pointer">{{
            $t("shippingDetail.viewRemainingOrder")
          }}</span></vs-divider
        >
        <vs-divider v-else></vs-divider>
        <div class="vx-col">
          <div class="flex justify-between flex-wrap">
            <vs-button @click="cancelOrderDialogVisibility = false" type="border" color="primary">
              <span class="text-capitalize">{{ $t("action.close") }}</span>
            </vs-button>
            <div class="vx-row">
              <vs-button
                class="float-right ml-2"
                @click="acceptCancelOrder({ cancel_bulk: false })"
                type="filled"
                color="primary"
              >
                <span class="text-capitalize">{{ $t("shippingDetail.cancelOrder") }}</span>
              </vs-button>
              <vs-button
                class="float-right ml-2"
                @click="acceptCancelOrder({ cancel_bulk: true })"
                type="gradient"
                color="primary"
                v-if="cancellable.cancellable_orders > 1"
              >
                <span class="text-capitalize">{{
                  $tc("shippingDetail.cancelOrderAction", 2, { count: cancellable.cancellable_orders })
                }}</span>
              </vs-button>
            </div>
          </div>
        </div>
        <div class="vx-col">
          <div class="mb-2" v-for="error in apiErrors" :key="error.message">
            <vs-alert color="danger" icon="new_releases">
              <span>{{ error }}</span>
            </vs-alert>
          </div>
        </div>
      </div>
    </vs-popup>
  </vx-card>
</template>

<style>
.vue-star-rating {
  display: block;
  margin-right: auto;
  margin-left: auto;
}
#shipping-detail .activity-desc {
  text-transform: capitalize;
}
</style>

<script>
import Crypto from "@/helper/crypto";
import Global from "@/helper/global";
import ErrorHandler from "@/helper/error_handler";
import VxDestination from "@/components/timeline/VxDestination.vue";
import StarRating from "vue-star-rating";
import { DeliveryTypeEnum, WaybillPaperSizeEnum } from "@/enums";

export default {
  name: "shipping-details",
  props: ["orderID", "selectedOrder"],
  data() {
    return {
      retrievedOrder: null,
      awbBase64: null,
      invoiceBase64: null,
      apiErrors: [],
      cancelErrors: [],
      enrouteErrors: [],
      ratingDialogVisibility: false,
      rate: {
        point: 0,
        note: "",
      },
      default_rate: {
        point: 0,
        note: "",
      },
      paperSizeDialogVisibility: false,
      cancelOrderDialogVisibility: false,
      enrouteOrderDialogVisibility: false,
      cancellable: {
        cancellable_orders: 0,
        order_single_refund: false,
        refund_percentage: 0,
        text: "",
      },
      cancelOrderDialogKey: 0,
    };
  },
  components: {
    VxDestination,
    StarRating,
  },
  computed: {
    deliveryTypeEnum: function() {
      return DeliveryTypeEnum;
    },
    waybillPaperSizes: function() {
      return WaybillPaperSizeEnum;
    },
    selectedOrderData: function() {
      return this.retrievedOrder ? this.retrievedOrder : this.selectedOrder;
    },
    showEnrouteButton: function() {
      let status =
        this.selectedOrderData.status == "ACCEPTED" ||
        (this.selectedOrderData.status == "DROPOFF" && this.selectedOrderData.is_round_trip);

      let sameday = this.selectedOrderData.delivery_type == this.deliveryTypeEnum.SAME_DAY_DELIVERY;
      let ondemand = this.selectedOrderData.delivery_type == this.deliveryTypeEnum.ON_DEMAND_DELIVERY;
      let nextday_premium = this.selectedOrderData.delivery_type == this.deliveryTypeEnum.NEXT_DAY_PREMIUM_DELIVERY;

      return status && (sameday || ondemand || nextday_premium);
    },
  },
  watch: {
    orderID: function(newValue, oldValue) {
      this.retrieveOrder();
    },
    retrievedOrder: function(newValue, oldValue) {
      this.awbBase64 = null;
      this.invoiceBase64 = null;
    },
  },
  mounted() {
    if (this.orderID) {
      this.retrieveOrder();
    }
  },
  methods: {
    retrieveOrder() {
      if (this.orderID) {
        this.apiErrors = [];
        this.$vs.loading({
          container: "#shipping-detail__body",
          scale: 0.6,
        });

        this.$http
          .get(this.$endpoints.customer_order + "/" + this.orderID)
          .then((res) => {
            this.retrievedOrder = res.data.data;
            if (this.retrievedOrder.delivery_type == DeliveryTypeEnum.INTERNATIONAL_DELIVERY) {
              this.retrieveDHLFile();
            }
          })
          .catch((err) => {
            //this.$vs.loading.close();
            this.apiErrors = ErrorHandler.processErrorMessage(err);
          })
          .finally(() => {
            this.$vs.loading.close("#shipping-detail__body > .con-vs-loading");
          });
      }
    },
    liveTracking() {
      if (this.selectedOrderData.unique_id) {
        return window.open(
          this.$endpoints.hostname + "/tracking/driver-location/" + this.selectedOrderData.unique_id,
          "_blank"
        );
      }

      return window.open(this.$endpoints.hostname + "/tracking", "_blank");
    },
    parseInt(string) {
      return parseInt(string);
    },
    onClickSubmitRate() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$vs.loading({
            type: "radius",
          });

          this.$http
            .post(this.$endpoints.customer_order + "/" + this.selectedOrderData.id + "/rate", {
              _method: "post",
              rating: this.rate.point,
              note: this.rate.note,
            })
            .then((res) => {
              this.apiErrors = [];
              this.$vs.loading.close();
              this.$vs.notify({
                color: "success",
                title: "VIAMOVE SYSTEM",
                text: res.data.message,
              });

              this.ratingDialogVisibility = false;

              this.$emit("refresh");
            })
            .catch((err) => {
              this.$vs.loading.close();
              this.apiErrors = ErrorHandler.processErrorMessage(err);
            });
        }
      });
    },
    openRatingDialog() {
      this.ratingDialogVisibility = true;
      this.rate = JSON.parse(JSON.stringify(this.default_rate));
    },
    goToTracking() {
      if (this.selectedOrderData && this.selectedOrderData.unique_id) {
        return window.open(this.$endpoints.hostname + "/tracking/" + this.selectedOrderData.unique_id, "_blank");
      }

      return window.open(this.$endpoints.hostname + "/tracking", "_blank");
    },
    goToExternalTracking() {
      if (this.selectedOrderData && this.selectedOrderData.external_tracking_url) {
        return window.open(this.selectedOrderData.external_tracking_url, "_blank");
      }
    },
    printWaybill() {
      this.paperSizeDialogVisibility = true;
    },
    onClickPrintWaybill(size) {
      window.open(
        this.$endpoints.customer_download +
          "/waybills/" +
          this.selectedOrderData.receipt.unique_id +
          "?paper_size=" +
          size,
        "_blank"
      );
    },
    printReceipt() {
      window.open(this.$endpoints.customer_download + "/receipt/" + this.selectedOrderData.receipt.unique_id, "_blank");
    },
    retrieveDHLFile() {
      this.$http
        .get(this.$endpoints.customer_order + "/" + this.selectedOrderData.id + "/dhl-file")
        .then((res) => {
          this.awbBase64 = res.data.data.awb_base64;
          this.invoiceBase64 = res.data.data.invoice_base64;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    printAirWaybill() {
      let pdfWindow = window.open("");
      pdfWindow.document.write("<iframe width='100%' height='100%' src='" + this.awbBase64 + "'></iframe>");
      return pdfWindow;
    },
    printInvoice() {
      let pdfWindow = window.open("");
      pdfWindow.document.write("<iframe width='100%' height='100%' src='" + this.invoiceBase64 + "'></iframe>");
      return pdfWindow;
    },
    enrouteOrder(request = {}) {
      this.$vs.loading({
        type: "radius",
      });

      this.$http
        .post(this.$endpoints.customer_order + "/" + this.selectedOrderData.id + "/enroute", request)
        .then((res) => {
          this.enrouteErrors = [];
          this.$vs.loading.close();
          this.enrouteOrderDialogVisibility = false;

          this.$vs.notify({
            color: "success",
            title: "VIAMOVE SYSTEM",
            text: res.data.message,
          });
          this.$emit("refresh");
        })
        .catch((err) => {
          this.$vs.loading.close();
          this.enrouteErrors = ErrorHandler.processErrorMessage(err);
        });
    },
    cancelOrder() {
      this.checkBalanceCancel()
        .then((res) => {
          this.cancellable = res.data.data;

          let text = "";

          if (this.selectedOrderData.delivery_type == this.deliveryTypeEnum.ONE_TO_THREE_DAYS_DELIVERY) {
            if (this.cancellable.order_single_refund) {
              text +=
                this.$t("shippingDetail.cancelStatement.refund", [this.cancellable.refund_percentage + "%"]) + ". ";
            } else {
              if (this.cancellable.refund_percentage_base_bulk) {
                text +=
                  this.$t("shippingDetail.cancelStatement.remainingOrder", {
                    base: 10,
                    remaining: this.cancellable.remaining_base_order_count,
                  }) + ". ";
              } else {
                text += this.$t("shippingDetail.cancelStatement.noRefund") + ". ";
              }
            }
          } else {
            let currency = this.cancellable.currency;
            text +=
              this.$t("shippingDetail.cancelStatement.refund", [
                this.renderCurrency(this.cancellable.refund_amount, currency),
              ]) + ". ";
          }

          text += "<br><br>" + this.$t("shippingDetail.cancelStatement.continue");

          this.cancellable.text = text;
          this.cancelOrderDialogVisibility = true;
        })
        .catch((err) => {
          console.log(err);
          this.apiErrors = ErrorHandler.processErrorMessage(err);
        });
    },
    acceptCancelOrder(request = {}) {
      this.$vs.loading({
        type: "radius",
      });

      this.$http
        .post(this.$endpoints.customer_order + "/" + this.selectedOrderData.id + "/cancel", request)
        .then((res) => {
          this.cancelErrors = [];

          this.cancelOrderDialogKey++;
          this.$vs.loading.close();
          this.$vs.notify({
            color: "success",
            title: "VIAMOVE SYSTEM",
            text: res.data.message,
          });

          this.closeCancelOrderDialog().then((res) => {
            this.$store.dispatch("updateSelectedOrder", { unique_id: null });
            this.$store.dispatch("updateCreatedOrders", []);

            this.$emit("refresh");
          });
        })
        .catch((err) => {
          this.$vs.loading.close();
          this.cancelErrors = ErrorHandler.processErrorMessage(err);
        });
    },
    reschedule() {
      this.$router.push({
        name: "order-reschedule",
        params: {
          orderID: this.selectedOrderData.id,
        },
      });
    },
    closeCancelOrderDialog() {
      return new Promise((resolve, reject) => {
        this.cancelOrderDialogVisibility = false;
        resolve(true);
      });
    },
    checkBalanceCancel() {
      this.$vs.loading({
        type: "radius",
      });

      return new Promise((resolve, reject) => {
        this.$http
          .get(this.$endpoints.customer_order + "/" + this.selectedOrderData.id + "/cancel-refund")
          .then((res) => {
            resolve(res);
            this.$vs.loading.close();
          })
          .catch((err) => {
            this.$vs.loading.close();
            reject(err);
          });
      });
    },
    renderTimelineData(order) {
      // console.log(order)
      let arr = [
        {
          color: "primary",
          icon: "MapPinIcon",
          title: order.sender_postal,
          desc:
            order.sender_name +
            " - " +
            order.sender_contact +
            (order.sender_instruction ? " - " + order.sender_instruction : ""),
          desc_2:
            order.sender_country +
            (order.sender_city ? " | " + order.sender_city : "") +
            (order.sender_address ? " | " + order.sender_address : "") +
            (order.sender_postal ? " | " + order.sender_postal : "") +
            (order.sender_unit ? " Unit: " + order.sender_unit : ""),
          active: true,
        },
      ];

      if (order.dropoff_count >= 2) {
        order.dropoffs.map((dropoff, index) => {
          let new_arr = {
            color: "success",
            icon: "MapPinIcon",
            title: dropoff.receiver_postal_code,
            desc:
              dropoff.receiver_name +
              " - " +
              dropoff.receiver_contact_no +
              (dropoff.receiver_instr ? " - " + dropoff.receiver_instr : ""),
            desc_2:
              dropoff.receiver_country +
              (dropoff.receiver_city ? " | " + dropoff.receiver_city : "") +
              (dropoff.receiver_address ? " | " + dropoff.receiver_address : "") +
              (dropoff.receiver_postal ? " | " + dropoff.receiver_postal : "") +
              (dropoff.receiver_unit ? " | Unit: " + dropoff.receiver_unit : ""),
            active: true,
          };

          arr.push(new_arr);
        });
      } else {
        arr.push({
          color: "success",
          icon: "MapPinIcon",
          title: order.receiver_postal,
          desc:
            order.receiver_name +
            " - " +
            order.receiver_contact +
            (order.receiver_instruction ? " - " + order.sender_instruction : ""),
          desc_2:
            order.receiver_country +
            (order.receiver_city ? " |" + order.receiver_city : "") +
            (order.receiver_address ? " | " + order.receiver_address : "") +
            (order.receiver_postal ? " | " + order.receiver_postal : "") +
            (order.receiver_unit ? " | Unit: " + order.receiver_unit : ""),
          active: true,
        });
      }

      return arr;
    },
    renderToHumanDate(datetime) {
      return Global.renderToHumanDate(datetime);
    },
    renderMoment(date, old_format, new_format) {
      return Global.renderDateByFormat(date, old_format, new_format);
    },
    checkIfSameMonthYear(date1, date2, format1, format2) {
      return this.renderMoment(date1, format1, "MM-YYYY") == this.renderMoment(date2, format2, "MM-YYYY");
    },
  },
};
</script>
